// Paysafi billing — flat Ksh 100 per tenant, counted against the
// peak number of active tenants during each 1-month billing cycle
// anchored to the user's signup day. Kept as a function (rather
// than a plain const) so we can retune pricing later without
// hunting for call sites.

export const FLAT_RATE = 100;

export function calculateBill(peakTenants) {
  if (!peakTenants || peakTenants <= 0) {
    return { rate: 0, subtotal: 0, total: 0 };
  }
  const total = peakTenants * FLAT_RATE;
  return { rate: FLAT_RATE, subtotal: total, total };
}

export const PAYBILL_NUMBER = "247247";

// Account number: 3-4 digit numeric code (100–9999).
export function generateAccountNumber() {
  return String(100 + Math.floor(Math.random() * 9900));
}

